import { useQuery } from "@tanstack/react-query";

import { fetchDataGet } from "@/core/api/api-methods";
import {
  DEFAULT_PAGE,
  DEFAULT_PAGE_SIZE,
  normalizePaged,
  type ListQueryParams,
  type Paged,
} from "@/core/api/pagination";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { adminEndpoints } from "@/features/admin/api/endpoints";
import type { SystemConfigDto } from "@/features/admin/api/dto";

/**
 * Clés de configuration système paginées
 * (`GET /SystemConfigs?page=&pageSize=`, guide §6.8 — réponse `Paged`) —
 * lecture authentifiée.
 */
export const useSystemConfigs = (params: ListQueryParams = {}, enabled = true) => {
  const page = params.page ?? DEFAULT_PAGE;
  const pageSize = params.pageSize ?? DEFAULT_PAGE_SIZE;
  return useQuery({
    queryKey: QUERY_KEYS.ADMIN_SYSTEM_CONFIGS_LIST({
      ...params,
      page,
      pageSize,
    }),
    queryFn: async () => {
      const data = await fetchDataGet<
        Paged<SystemConfigDto> | SystemConfigDto[] | SystemConfigDto
      >({
        url: adminEndpoints.systemConfigs.all,
        queryParams: {
          ...params.filters,
          page: String(page),
          pageSize: String(pageSize),
        },
      });
      return normalizePaged(data, pageSize);
    },
    retry: (failureCount, error) =>
      !/401/.test(error?.message ?? "") && failureCount < 1,
    enabled,
  });
};
